import { render } from "./MergeStudy.vue?vue&type=template&id=5ea23299&scoped=true"
import script from "./MergeStudy.vue?vue&type=script&lang=js"
export * from "./MergeStudy.vue?vue&type=script&lang=js"

import "./MergeStudy.vue?vue&type=style&index=0&id=5ea23299&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea23299"]])

export default __exports__